<template>
    <div class="goodCenter">
        <ul>
            <li v-for="(item) in list" :key="item.class_code" @click="classCode(item)">
               <div class="item fontSong12">{{item.class_name}}<div class="verdanF12 itemCount">{{item.total}}件</div></div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "goodCenter",
    props: ["list"],
    data(){
        return{
            dataList:[
                {id:1,name:'中国书画',count:'20.7万件',code:'item-2-0-0'},
                {id:3,name:'中国书画',count:'20.7万件',code:'item-2-0-0'},
                {id:4,name:'中国书画',count:'20.7万件',code:'item-2-0-0'},
                {id:5,name:'中国书画',count:'20.7万件',code:'item-2-0-0'},
                {id:6,name:'中国书画',count:'20.7万件',code:'item-2-0-0'},
                {id:7,name:'中国书画',count:'20.7万件',code:'item-2-0-0'},
                {id:8,name:'中国书画',count:'20.7万件',code:'item-2-0-0'},
                {id:9,name:'中国书画',count:'20.7万件',code:'item-2-0-0'},
                {id:10,name:'中国书画',count:'20.7万件',code:'item-2-0-0'},
                {id:11,name:'中国书画',count:'20.7万件',code:'item-2-0-0'},
            ],
            webName: ''
        }
    },
    mounted() {
        this.webName = this.$router.history.current.params.name;
    },
    methods: {
        classCode(item) {
            this.$router.push(`/${this.webName}/item?code=${item.class_code}00000000`)
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/assets/css/auctionCompany.scss';
.goodCenter{
    ul{
        li{
            width: calc(50% - 1px);
            display: inline-block;
            margin-right: 2px;
            margin-bottom: 2px;
            .item{
                display: block;
                // height: 40px;
                line-height: 40px;
                background: #efefef;
                text-align: left;
                padding-left: 10px;
                padding-bottom: 10px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                cursor: pointer;

                span{
                    color: #999;
                }

                &:hover{
                    background: #000;
                    color: #fff;
                    font-weight: bold;
                    .itemCount{
                        color:#ffffff;
                        font-weight: bold;
                    }
                }
            }
            &:nth-child(2n){
                margin-right: 0;
            }
        }
    }
}
</style>